import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entwicklungsprozesse-mobile',
  templateUrl: './entwicklungsprozesse-mobile.component.html',
  styleUrls: ['./entwicklungsprozesse-mobile.component.scss']
})
export class EntwicklungsprozesseMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
